// web/src/admin/AdminShell.tsx — route gate for /admin/*. Renders children only when me.isAdmin; otherwise a
// 404-style screen (D15 §3 hides that /admin exists for non-admins). The nav is also hidden in AppShell.
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { Skeleton } from '../components/Skeleton';
import { Icon } from '../components/Icon';
import { AdminTabs } from './adminNav';

export function AdminGate({ children }: { children: ReactNode }) {
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me() });
  if (me.isLoading) return <Skeleton variant="card" count={3} />;
  if (!me.data?.isAdmin) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-lg border border-hair bg-surface/40 px-6 py-16 text-center">
        <span className="flex size-12 items-center justify-center rounded-full bg-surface2 text-muted"><Icon name="alert" size={24} /></span>
        <h1 className="font-head text-lg text-ink">404 — Not found</h1>
        <p className="max-w-sm text-sm text-muted">This page doesn’t exist.</p>
        <Link to="/" className="mt-1 inline-flex min-h-11 items-center gap-2 rounded-md border border-hair px-4 text-sm text-ink"><Icon name="home" size={16} />Go home</Link>
      </div>
    );
  }
  // Portal spec 22: on a phone the operator nav is a row of pills above every admin page (the sidebar is desktop-only).
  return <><AdminTabs />{children}</>;
}
